import type { PatchProjectInput } from '@/api/projectApi'
import { resolveLocalized } from '@/i18n/resolveLocalized'
import type { GenreTemplate, Project } from '@/types/nf'

export const projectSettingsFieldKeys = [
  'author',
  'world_time_period',
  'world_location',
  'world_atmosphere',
  'world_rules',
  'core_theme',
  'logline',
  'antagonist_source',
  'tone_keynote',
  'narrative_perspective',
  'content_language',
] as const

export type ProjectSettingsFieldKey = (typeof projectSettingsFieldKeys)[number]
export type ProjectSettingsValues = Record<ProjectSettingsFieldKey, string>

export function getProjectSettingsInitialValues(project: Project): ProjectSettingsValues {
  return {
    author: project.author ?? '',
    world_time_period: project.world_time_period ?? '',
    world_location: project.world_location ?? '',
    world_atmosphere: project.world_atmosphere ?? '',
    world_rules: project.world_rules ?? '',
    core_theme: project.core_theme ?? '',
    logline: project.logline ?? '',
    antagonist_source: project.antagonist_source ?? '',
    tone_keynote: project.tone_keynote ?? '',
    narrative_perspective: project.narrative_perspective ?? '',
    content_language: project.content_language ?? '',
  }
}

export function buildProjectSettingsPatch(project: Project, values: ProjectSettingsValues): PatchProjectInput {
  const initialValues = getProjectSettingsInitialValues(project)
  return projectSettingsFieldKeys.reduce<PatchProjectInput>((patch, key) => {
    if (values[key] !== initialValues[key]) {
      patch[key] = values[key]
    }
    return patch
  }, {})
}

export function hasProjectSettingsChanges(project: Project, values: ProjectSettingsValues): boolean {
  return Object.keys(buildProjectSettingsPatch(project, values)).length > 0
}

export function resolveWorldRulesLabel(
  template: GenreTemplate | undefined,
  lang: string,
  fallback: string,
): string {
  return resolveLocalized(template?.payload.world_rules_label, lang) || fallback
}
